<script>
import Multiselect from "vue-multiselect";

export default {
  name: "CompactMultiSelect",
  components: { Multiselect },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Selecione...",
    },
    trackBy: {
      type: String,
      default: "id",
    },
    label: {
      type: String,
      default: "name",
    },
    maxVisible: {
      type: Number,
      default: 2,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    remove(item) {
      this.$emit("remove", item[this.trackBy]);
    },
  },
};
</script>

<template>
  <Multiselect
    v-model="model"
    :options="options"
    :multiple="true"
    :close-on-select="false"
    :track-by="trackBy"
    :label="label"
    :placeholder="placeholder"
  >
    <template #selection="{ values }">
      <span v-if="values.length === 0"></span>

      <span
        v-for="item in values.slice(0, maxVisible)"
        :key="item[trackBy]"
        class="multiselect__tag"
      >
        {{ item[label] }}
        <i
          class="multiselect__tag-icon"
          @click.stop="remove(item)"
        ></i>
      </span>

      <span v-if="values.length > maxVisible" class="multiselect__tag">
        +{{ values.length - maxVisible }}
      </span>
    </template>
  </Multiselect>
</template>

<style lang="scss">
.multiselect__tag {
  color: #1a52db;
  background-color: #eff6ff !important;
}

.multiselect__tag-icon {
  color: #1a52db;

  &:after {
    color: #1a52db !important;
  }

  &:focus,
  &:hover {
    background-color: #eff6ff;
    color: #1a52db;
  }
}

.multiselect__option {
  color: #999e9d;
  font-size: 13px;

  &--selected {
    background: #eff6ff !important;
    color: #1a52db !important;

    &::after {
      display: none;
    }
  }

  &--highlight {
    background: #eff6ff !important;
    color: #999e9d;

    &::after {
      display: none;
    }

    &:hover {
      color: #999e9d !important;
    }
  }
}
</style>
